export default
    {
        // url: this.$store.state.http.hc.YYYY,
        guarda: "/historiaclinica/guardaSf",
        list: "/historiaclinica/listSf",
        imprime: "/historiaclinica/imprimeSf",

        listHcReportes: "/historiaclinica/listHcReportes",
    }
